import { useState, useEffect, useContext, useMemo } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { makeStyles } from "@material-ui/styles";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import { AppbarItemsType } from "../constants/types";
import { UserContext } from "../store/UserContextProvider";
import { logoutManager } from "../managers/authManager";
import { Theme } from "@mui/material/styles";

const useStyles = makeStyles((theme: Theme) => ({
  appBar: {
    width: "100%",
    position: "sticky",
    top: 0,
    backgroundColor: theme.aapnoParichayTheme.primaryContainer,
  },
  title: {
    flexGrow: 1,
  },
  link: {
    color: theme.aapnoParichayTheme.onPrimaryContainer,
    transition: "color 0.3s ease",
  },
  activeLink: {
    color: "#fff",
  },
}));

const ApAppbar = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { isUserAuthenticated = false, setDataOnLogout } =
    useContext(UserContext);

  const classes = useStyles();
  const loggedOutAppbarItems: AppbarItemsType[] = useMemo(
    () => [{ label: "Login", url: "/login" }],
    []
  );

  const [appbarItems, setAppbarItems] =
    useState<AppbarItemsType[]>(loggedOutAppbarItems);

  const handleLinkClick = (url: string) => {
    if (url.includes("logout")) {
      logoutManager();
      setDataOnLogout();
      return;
    }
    navigate(url);
  };

  useEffect(() => {
    const commonAppbarItems: AppbarItemsType[] = [{ label: "Home", url: "/" }];

    const loggedInAppbarItems: AppbarItemsType[] = [
      { label: "Dashboard", url: "/dashboard" },
      { label: "Logout", url: "/logout" },
    ];

    let formattedAppbarItems = [...commonAppbarItems];
    if (isUserAuthenticated) {
      formattedAppbarItems = formattedAppbarItems.concat(loggedInAppbarItems);
    } else {
      formattedAppbarItems = formattedAppbarItems.concat(loggedOutAppbarItems);
    }
    setAppbarItems(formattedAppbarItems);
  }, [isUserAuthenticated, loggedOutAppbarItems, pathname]);

  return (
    <AppBar position="static" className={classes.appBar}>
      <Toolbar>
        <Typography variant="h6" className={classes.title}></Typography>
        <ul style={{ display: "flex", listStyle: "none" }}>
          {appbarItems.map(({ label, url = "" }, index: number) => (
            <li key={index} style={{ marginLeft: "16px", cursor: "pointer" }}>
              <Typography
                variant="h6"
                className={classes.link}
                onClick={() => handleLinkClick(url)}
              >
                {label}
              </Typography>
            </li>
          ))}
        </ul>
      </Toolbar>
    </AppBar>
  );
};

export default ApAppbar;
